import { queryClient } from "components/queryClient";
import { persistor } from "index";
import { LOGOUT } from "store/reducers/auth";
import { deleteUser } from "store/reducers/userSlice";

/**
 * 🔥 모든 로그아웃의 단일 진입점
 */
export const forceLogout = async (dispatch, navigate) => {
  try {
    dispatch(LOGOUT());
    dispatch(deleteUser());

    // ⭐ React Query 캐시 삭제
    queryClient.clear();

    await persistor.purge();
    sessionStorage.removeItem("accessLogId");
  } finally {
    navigate("/auth/login", { replace: true });
  }
};
